<template>
<div>

    <CModal
                :show.sync="isShowAgentDpModal"
                size="xl"
                class="sub-dash-wrap"
                :closeOnBackdrop="false"
        >
      
            <template #header-wrapper>
              <div></div>
                <!-- <CCardHeader>
                    <div class="title">
                        <div class="left">
                            <h1><strong>{{selAgent.agentname}}</strong></h1>
                            <p>
                               {{selAgent.b2bcode}}
                            </p></div>

                            
                        <div @click="closeModal" class="right">
                            <img class="close" src="@imgPath/img/svg/icons/cross.svg" alt="">
                        </div>
                    </div>
                    <div class="d-flex align-item-center">
                        <ul class="nav nav-pills">
                            <li @click="toGetAgtDBReq('THISMONTH')" :class="status=='Month'?'active':'no-class'">Month</li>
                            <li @click="toGetAgtDBReq('THISWEEK')" :class="status=='Week'?'active':'no-class'">Week</li>
                            <li @click="toGetAgtDBReq('TODAY')" :class="status=='Today'?'active':'no-class'">Today</li>
                            <li @click="toGetAgtDBReq('CUSTOM')" :class="status=='Custom'?'active':'no-class'">Custom</li>
                        </ul>
                        <HotelDatePicker
                                v-if="status=='Custom'"
                                :showYear="true"
                                :startDate="new Date(null)"
                                :startingDateValue="new Date(custom.fromDate)"
                                :endingDateValue="new Date(custom.toDate)"
                                :hoveringTooltip="false"
                                :displayClearButton="false"
                             
                                @check-in-changed="getFromDate"
                                @check-out-changed="getToDate"
                                :singleDaySelection="false"
                                :i18n="assigni18nObjByLang()"
                                ref="flightDatePicker"
                                :minNights="0"
                                :enableCheckout="true"

                        />

                    </div>

                </CCardHeader> -->
            </template>
       <cFullScreen>
          <template #fullScreen>
        <div class="dashboard-wrapper">
           <CCardHeader>
                    <div class="title">
                        <div v-if="selAgent" class="left">
                            <h1><strong>{{selAgent.agentname}}</strong></h1>
                            <p>
                               {{selAgent.b2bcode}}
                            </p></div>

                             <div v-if="selAgentgroup" class="left">
                            <h1><strong>{{selAgentgroup.groupname}}</strong></h1>
                            <p>
                               {{selAgentgroup.description}}
                            </p>
                            </div>
                            
                        <div @click="closeModal" class="right">
                            <img class="close" src="@imgPath/img/svg/icons/cross.svg" alt="">
                        </div>
                    </div>
               <br />
                    <div class="d-flex align-item-center">
                        <ul class="nav nav-pills">
                            <li @click="toGetAgtDBReq('THISMONTH')" :class="status=='Month'?'active':'no-class'">{{$t('dashBoard.cSysMiniAgentDB.month')}}</li>
                            <li @click="toGetAgtDBReq('THISWEEK')" :class="status=='Week'?'active':'no-class'">{{$t('dashBoard.cSysMiniAgentDB.week')}}</li>
                            <li @click="toGetAgtDBReq('TODAY')" :class="status=='Today'?'active':'no-class'">{{$t('dashBoard.cSysMiniAgentDB.today')}}</li>
                            <li @click="toSetCustomDateRange()" :class="status=='Custom'?'active':'no-class'">{{$t('dashBoard.cSysMiniAgentDB.custom')}}</li>
                        </ul>
                        <!-- <HotelDatePicker
                                v-if="status=='Custom'"
                                :showYear="true"
                                :startDate="new Date(null)"
                                :startingDateValue="new Date(custom.fromDate)"
                                :endingDateValue="new Date(custom.toDate)"
                                :hoveringTooltip="false"
                                :displayClearButton="false"
                             
                                @check-in-changed="getFromDate"
                                @check-out-changed="getToDate"
                                :singleDaySelection="false"
                                :i18n="assigni18nObjByLang()"
                                ref="flightDatePicker"
                                :minNights="0"
                                :enableCheckout="true"

                        /> -->
                       <div class="ext-date-wrapper box-shadow left">
                                                 <v-md-date-range-picker
    :start-date="custom.fromDate?custom.fromDate.toString():new Date().toString()"
    :end-date="custom.toDate?custom.toDate.toString():new Date().toString()"
    :autoApply="true"
    :showYearSelect="true"
    :maxYear="getMaxYear()"
    :minYear="getMinYear()"
    @change="onChangeDate"
  >
  <template slot="input">
       <datePickerInput :fromDate="custom.fromDate?custom.fromDate:null" 
       :toDate="custom.toDate?custom.toDate:null" :fromLabel="$t('dashBoard.cSysMiniAgentDB.fromLabel')" :toLabel="$t('dashBoard.cSysMiniAgentDB.toLabel')"/>
    
  </template>
  </v-md-date-range-picker></div>

                    </div>

                </CCardHeader>
                <div class="system-dash-wrapper">
                   
                    <cAgtDBBookingNo v-if="sysBookingNum && agentDBReq && isRptTypeChanged"
                    :isAgentGroup="selAgentgroup?true:false" :selAgent="agentDBReq"  :sysBookingNum="sysBookingNum"></cAgtDBBookingNo>
                    <!--                <cSysBookingNo :prgrsBarData="dayToDaySalesRes"></cSysBookingNo>-->
                    <div class="row">
                        <div class="col-md-4">
                            <div class="campaign-gra-wrap p-20px bg-white">
                              
                                <cAgtDBTotalBookings v-if="sysBookingNum && agentDBReq && isRptTypeChanged" 
                                :isAgentGroup="selAgentgroup?true:false" :status="status" :sysBookingNum="sysBookingNum"></cAgtDBTotalBookings>
                            </div>
                            <cAgtDBSearchCount v-if="agentDBReq && isRptTypeChanged"  :selAgent="agentDBReq"></cAgtDBSearchCount>
                             
                           
                        </div>
                       
                        <div class="col-md-8">
                            <cAgtDBWeeklySales :isAgentGroup="selAgentgroup?true:false" v-if="agentDBReq && isRptTypeChanged"  :selAgent="agentDBReq"></cAgtDBWeeklySales>
                             <cSysUserLoginActivity v-if="selAgentgroup"></cSysUserLoginActivity>
                             <!-- <cSysDayToDaySales v-if="dayToDaySalesRes && sysBookingNum && selAgentgroup" 
                            :sysBookingNum="sysBookingNum" :dayToDaySalesRes="dayToDaySalesRes">
                            </cSysDayToDaySales> -->
                            
                        </div>
                         <div class="col-md-6">
                             <cSysDayToDaySales v-if="dayToDaySalesRes && sysBookingNum && selAgentgroup" 
                            :sysBookingNum="sysBookingNum" :dayToDaySalesRes="dayToDaySalesRes">
                            </cSysDayToDaySales>
                             </div>
                        
                        <div  class="col-md-6">
                           <cAgtDBAgentSales v-if="selAgentgroup" :isAgentGroup="selAgentgroup?true:false" :selAgent="selAgentgroup"></cAgtDBAgentSales>

                        </div>
                    </div>
                </div>
                <CElementCover v-if="isLoading" :opacity="0.8"/>
            </div>
          </template>
       </cFullScreen>
          


   </CModal>
</div>
</template>

<script>
import Logger from "../../../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, { navigate, goBack } from "../../../../router/index";
import apib2bSysBookingNo from "./../../../../services/apib2bSysBookingNo";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import HotelDatePicker from 'vue-range-datechooser'
import cAgtDBSearchCount from './cAgtDBSearchCount';
import cAgtDBWeeklySales from './cAgtDBWeeklySales';
import cAgtDBTotalBookings from './cAgtDBTotalBookings';
import cAgtDBBookingNo from './cAgtDBBookingNo';
import cSysDayToDaySales from '../cSysDayToDaySales';
import cAgtDBAgentSales from './cAgtDBAgentSales';
import cSysUserLoginActivity from '../cSysUserLoginActivity';
import { COMPONENT_NAME, PATHNAME, AGENT_DB_REPORT_TYPE,DATE_TIME_FORMAT } from "../../../../util/constants";
import BaseConfiguration from "../../../../config/base.js";
import SERVICE_URL from "../../../../config/API_DATA";
import {
  dateFunctions,
  getDiffBtwDates,
  addDays,
  formatDate
} from "../../../../util/date/dateFunctions";
import { mapGetters, mapActions } from "vuex";
import { handleJWT, getErrorAlertValue } from "../../../../util/util";
import {
        setSelRptTypeFromLocal,
        getSelRptTypeFromLocal,

    } from '../../../../applocalstorage/localStorage'
     import datePickerInput from "../../../../components/datePicker/datePickerInput";
import {VMdDateRangePicker} from "material-vue-date-picker";
import cFullScreen from "../../../../components/cFullScreen";

    import apiDayToDaySales from "./../../../../services/apiDayToDaySales";
export default {

    name: COMPONENT_NAME.C_SYS_MINI_AGT_DB,

    components:{
      cAgtDBAgentSales,
        cAgtDBSearchCount,
        cAgtDBWeeklySales,
        cAgtDBTotalBookings,
        cAgtDBBookingNo,
        HotelDatePicker,
        datePickerInput,
        VMdDateRangePicker,
        cFullScreen,
        cSysDayToDaySales,
        cSysUserLoginActivity,
        
    },

    props:{
      selAgentgroup:{
        type: Object|Array,
        default:null
      },
        selAgent:{
            type: Object,
            default: null
        },
        isShowAgentDpModal:{
            type: Boolean,
            default: false
        }
    },

  data () {
    return {
       sysBookingNum : null,
       agentDBReq:null,
       isRptTypeChanged:true,
       status: null,
       custom: {
           fromDate:null,
           toDate:null
       },
       isLoading:true,
       dayToDaySalesRes: null,
      // fullscreen: false
    }
   },
       computed:{
          DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          }
  
   },
    async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {

               if (this.selAgentgroup) {
                  
                    this.dayToDaySalesRes = await this.getDayToDaySales();
                    // this.sysBookingNum = await this.getSysBookingNumber();

                }

                let selRptType = getSelRptTypeFromLocal();

                var firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                var lastDay = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

                this.custom.fromDate = this.$options.filters.formatDate(firstDay, DATE_TIME_FORMAT.API_DATE_FORMAT);
                this.custom.toDate = this.$options.filters.formatDate(lastDay, DATE_TIME_FORMAT.API_DATE_FORMAT);
                // alert('asdasd'+selRptType)
                if(selRptType=="null" || selRptType==null){
                    this.agentDBReq = this.toGetAgtDBReq(AGENT_DB_REPORT_TYPE.THISMONTH);
                }else{
                    this.agentDBReq = this.toGetAgtDBReq(selRptType);
                }
                
                    // this.sysBookingNum = await this.getSysBookingNumber(this.agentDBReq);
                
                
                //   this.toGetPrgrsBarMaxVal(this.prgrsBarData);
                
                
                let that = this;
               setTimeout(function(){
                    that.isLoading = false;
               },1200);
              
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_SYS_MINI_AGT_DB,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

         methods: {
           
      //          toggle () {
      //   this.$refs['fullscreen'].toggle() // recommended
      //   // this.fullscreen = !this.fullscreen // deprecated
      // },
      // fullscreenChange (fullscreen) {
      //   this.fullscreen = fullscreen
      // },

      async getDayToDaySales() {
                let returnValue;
                try {
                    let dayToDaySalesReq = apiDayToDaySales.buildRequest();
                    if (dayToDaySalesReq) {
                        let dayToDaySalesRes = await apiDayToDaySales.getResponse(dayToDaySalesReq);
                        if (VALIDATE_SUCCESS_RES(dayToDaySalesRes)) {
                            returnValue = dayToDaySalesRes.data.data;

                        } else {
                            let error = getErrorMessage(dayToDaySalesRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.DASHBOARD,
                        "error in  getDayToDaySales",
                        err.toString(),
                        " getDayToDaySales()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },
             showAlert(val) {
                this.$emit("showAlert", val);
            },

             closeModal(){
                 this.$emit('closeDBModal',false);
             },
              
               onChangeDate(pDateList) {
          try {
            if(BaseConfiguration.isDebug) console.log("onChangeDate");
          //  console.error(pDateList)
        //    this.fromDate=pDateList[0]._d;
           this.setFromDate(pDateList[0]._d);
           this.setToDate(pDateList[1]._d);
            //  this.toDate=pDateList[1]._d;
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_SYS_MINI_AGT_DB,
                    "error in onChangeDate",
                    err.toString(),
                    "onChangeDate",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 
          setToDate(pDate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("setToDate");

                    if (pDate) {
                        this.custom.toDate = pDate;
                        this.toGetAgtDBReq('CUSTOM');
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYS_MINI_AGT_DB,
                        "error in setToDate",
                        err.toString(),
                        "setToDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
          },

            setFromDate(pDate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("setFromDate");

                    if (pDate) {
                        this.custom.fromDate = pDate;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYS_MINI_AGT_DB,
                        "error in setFromDate",
                        err.toString(),
                        "setFromDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

        getMinYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMinYear");
           retValue=(new Date().getFullYear()-10)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_SYS_MINI_AGT_DB,
                    "error in getMinYear",
                    err.toString(),
                    "getMinYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
        }, 

      getMaxYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMaxYear");
           retValue=(new Date().getFullYear()+1)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_SYS_MINI_AGT_DB,
                    "error in getMaxYear",
                    err.toString(),
                    "getMaxYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
      }, 

    assigni18nObjByLang() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");
      
        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat")
          ],
          "check-in":   this.custom.fromDate,
          // this.$t("flightDatePicker.checkIn"),
          // "check-out":"",
          "check-out": formatDate(addDays(new Date(this.custom.toDate),7)),
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec")
          ]
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SEARCH,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

            
               ///to get departure date
    getFromDate(selectedDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("getFromDate");
            this.custom.fromDate = selectedDate;
            this.custom.toDate = selectedDate;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SYS_MINI_AGT_DB,
          "error in getFromDate ",
          err.toString(),
          "getFromDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

      ///to get departure date
    getToDate(selectedDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("getToDate");
        if(selectedDate!=null){
        this.custom.toDate = selectedDate;
        
        this.toGetAgtDBReq('CUSTOM');
        }
             
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SYS_MINI_AGT_DB,
          "error in getToDate ",
          err.toString(),
          "getToDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getSysBookingNoOnchange(){
        try{
            this.sysBookingNum = await this.getSysBookingNumber(this.agentDBReq);
        } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_SYS_MINI_AGT_DB,
          "error in getSysBookingNoOnchange ",
          err.toString(),
          "getSysBookingNoOnchange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    toSetCustomDateRange(){
      var firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                var lastDay = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

                this.custom.fromDate = this.$options.filters.formatDate(firstDay, DATE_TIME_FORMAT.API_DATE_FORMAT);
                this.custom.toDate = this.$options.filters.formatDate(lastDay, DATE_TIME_FORMAT.API_DATE_FORMAT);
                this.toGetAgtDBReq('CUSTOM');
    },

              toGetAgtDBReq(pReportType) {
                 let retValue={
                     b2bid:null,
                     reportType:null,
                     fromDate:null,
                     toDate:null,
                     groupId: null
                 };
                 try {
                   if(BaseConfiguration.isDebug) console.log("toGetAgtDBReq");
                   if(this.selAgent) {
                       retValue.b2bid = this.selAgent.b2bid;
                   }if(this.selAgentgroup) {
                     retValue.groupId = this.selAgentgroup.b2bGroupid;
                   }
                   setSelRptTypeFromLocal(pReportType)
                   this.sysBookingNum=null;

                   if(pReportType ==  AGENT_DB_REPORT_TYPE.THISMONTH || pReportType == AGENT_DB_REPORT_TYPE.THISWEEK || pReportType == AGENT_DB_REPORT_TYPE.TODAY) {
                       retValue.fromDate = null;
                       retValue.toDate = null;
                       retValue.reportType = pReportType;
                       this.isRptTypeChanged = false;
                   }

                   if(pReportType ==  AGENT_DB_REPORT_TYPE.THISMONTH ) {
                      this.status = 'Month';
                      var firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                var lastDay = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

                this.custom.fromDate = this.$options.filters.formatDate(firstDay, DATE_TIME_FORMAT.API_DATE_FORMAT);
                this.custom.toDate = this.$options.filters.formatDate(lastDay, DATE_TIME_FORMAT.API_DATE_FORMAT);
                   }
                   else if(pReportType == AGENT_DB_REPORT_TYPE.THISWEEK ) {
                       this.status = 'Week';
                       var curr = new Date;
                var first = curr.getDate() - curr.getDay(); 
                var last = first + 6;

                var firstday = new Date(curr.setDate(first)).toUTCString();
                var lastday = new Date(curr.setDate(last)).toUTCString();

                this.custom.fromDate = this.$options.filters.formatDate(firstday, DATE_TIME_FORMAT.API_DATE_FORMAT);
                this.custom.toDate = this.$options.filters.formatDate(lastday, DATE_TIME_FORMAT.API_DATE_FORMAT);
                   }

                   else if(pReportType == AGENT_DB_REPORT_TYPE.TODAY) {
                       this.status = 'Today';
                       this.custom.fromDate = this.$options.filters.formatDate(new Date, DATE_TIME_FORMAT.API_DATE_FORMAT);
                this.custom.toDate = this.$options.filters.formatDate(new Date, DATE_TIME_FORMAT.API_DATE_FORMAT);
                   }

                   else if(pReportType == AGENT_DB_REPORT_TYPE.CUSTOM) {
                       this.status = 'Custom';
                
                       retValue.reportType = pReportType;
                       this.isRptTypeChanged = false;
                       retValue.fromDate = this.$options.filters.formatDate(this.custom.fromDate, DATE_TIME_FORMAT.API_DATE_FORMAT);
                       retValue.toDate = this.$options.filters.formatDate(this.custom.toDate, DATE_TIME_FORMAT.API_DATE_FORMAT);
                   }
                    

                   if(this.status=='Custom') {
                       if(retValue.fromDate!=null && retValue.toDate!=null) {
                          
                           this.agentDBReq = retValue;
                           
                           let that = this;
                        setTimeout(function() {
                            that.isRptTypeChanged = true;
                         });
                       }
                   }else{
                    this.agentDBReq = retValue;
                           
                   
                   let that = this;
                        setTimeout(function() {
                            that.isRptTypeChanged = true;
                         });
                   }
                   this.getSysBookingNoOnchange();
                   
                 } catch (err) {
                         let body = Logger.buildRequest(
                           COMPONENT_NAME.C_SYS_MINI_AGT_DB,
                           "error in toGetAgtDBReq",
                           err.toString(),
                           "toGetAgtDBReq",
                           LOG_TYPE.ERROR
                         );
                         Logger.getResponse(body);
                       }
                   return retValue;
       }, 

      toGetPrgrsBarMaxVal(pdayToDaySalesRes) {
          let sales=0;
          let issuedbookings=0;
          try {
            if(BaseConfiguration.isDebug) console.log("toGetPrgrsBarMaxVal");
           if(pdayToDaySalesRes){
              
                if(pdayToDaySalesRes.dayTodaySales.lastweek_sameday){
                    for (let i = 0; i < pdayToDaySalesRes.dayTodaySales.lastweek_sameday.length; i++) {
                        sales+=pdayToDaySalesRes.dayTodaySales.lastweek_sameday[i].json_build_object.Sales;
                        issuedbookings+=pdayToDaySalesRes.dayTodaySales.lastweek_sameday[i].json_build_object.IssuedBookings;
                      
                    }
                }
            } 
            this.salesMaxVal = sales;
            this.issuedMaxVal = issuedbookings;
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_SYS_MINI_AGT_DB,
                    "error in toGetPrgrsBarMaxVal",
                    err.toString(),
                    "toGetPrgrsBarMaxVal",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 

       async getSysBookingNumber(pagentDBReq) {
                if (BaseConfiguration.isDebug) console.log("getSysBookingNumber");
                let returnValue;
                try {
                    let getBookingNumberReq = apib2bSysBookingNo.buildRequest(pagentDBReq); //constant

                    if (getBookingNumberReq != null) {
                        let getBookingNumberRes = await apib2bSysBookingNo.getResponse(
                            getBookingNumberReq
                        );
                        if (VALIDATE_SUCCESS_RES(getBookingNumberRes)) {
                            returnValue = getBookingNumberRes.data.data;

                        } else {
                            let error = getErrorMessage(getBookingNumberRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYS_MINI_AGT_DB,
                        "error in  getSysBookingNumber",
                        err.toString(),
                        "getSysBookingNumber()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },
  }

}
</script>
<style scoped>
img.fullscreen-btn.translatey-0px.mr-0 {
    -webkit-transform: translate(-7px,45px)!important;
    transform: translate(-7px,105px)!important;
    z-index: 999999;
}
.ext-date-wrapper.box-shadow.left {
    max-width: 60%;
}
</style>